import { TextField } from '~/components/form';
import { KEY_DASH_HINT, toUnderscoreKey } from '~/lib/ai/keyFormat';

interface PlacementIdentityFieldsProps {
  name: string;
  placementKey: string;
  onNameChange: (value: string) => void;
  onNameBlur: () => void;
  nameError?: string;
  /** Creating: the key is typed and required. Editing: it is shown read-only. */
  isNew: boolean;
  onKeyChange?: (value: string) => void;
  onKeyBlur?: () => void;
  keyError?: string;
}

/**
 * The Name and Placement key fields (two cells of the page's grid), shared by `/ai/placements/new`
 * and the editor's Details section.
 */
export default function PlacementIdentityFields({
  name,
  placementKey,
  onNameChange,
  onNameBlur,
  nameError,
  isNew,
  onKeyChange,
  onKeyBlur,
  keyError,
}: PlacementIdentityFieldsProps) {
  return (
    <>
      <TextField
        id="ai-placement-name"
        label="Name"
        testId="ai-placement-name"
        required={isNew}
        value={name}
        onChange={onNameChange}
        onBlur={onNameBlur}
        error={nameError}
        placeholder={isNew ? 'Example: Blog body' : undefined}
        helperText="Shown in lists, breadcrumbs and version history."
      />
      <TextField
        id="ai-placement-key"
        label="Placement key"
        testId="ai-placement-key"
        required={isNew}
        code
        readOnly={!isNew}
        value={placementKey}
        onChange={onKeyChange ?? (() => undefined)}
        transform={toUnderscoreKey}
        transformHint={isNew ? KEY_DASH_HINT : undefined}
        onBlur={onKeyBlur}
        error={keyError}
        placeholder={isNew ? 'Example: blog.body' : undefined}
        helperText={
          isNew
            ? 'Lowercase letters, numbers, . and _. The app renders the component with this key.'
            : 'The app renders this component with this key. It cannot change after creation.'
        }
      />
    </>
  );
}
